import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const EntryCardStyled = styled.div`
  background: white;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  position: relative;

  @media (max-width: ${screenSizes.mobile}) {
    border-radius: 0.75rem;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    @media (max-width: ${screenSizes.mobile}) {
      transform: none; /* Disable hover effect on mobile */
    }
  }

  &:active {
    @media (max-width: ${screenSizes.mobile}) {
      transform: scale(0.98);
    }
  }

  .card-header {
    position: relative;
    height: 160px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    @media (max-width: ${screenSizes.mobile}) {
      height: 120px;
    }

    &.type-text {
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    }

    &.type-video {
      background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    }

    &.type-pdf {
      background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
    }

    &.type-link {
      background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
    }

    &.type-quiz {
      background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    }

    .type-icon {
      font-size: 3rem;
      color: rgba(255, 255, 255, 0.9);

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 2.5rem;
      }
    }

    .read-badge {
      position: absolute;
      top: 1rem;
      right: 1rem;
      padding: 0.25rem 0.75rem;
      border-radius: 9999px;
      font-size: 0.625rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      background-color: rgba(16, 216, 180, 0.9);
      color: white;
      display: flex;
      align-items: center;
      gap: 0.25rem;

      @media (max-width: ${screenSizes.mobile}) {
        top: 0.5rem;
        right: 0.5rem;
        padding: 0.2rem 0.5rem;
        font-size: 0.55rem;
      }
    }

    .unread-indicator {
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 12px;
      height: 12px;
      background-color: #ef4444;
      border-radius: 50%;
      border: 2px solid white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

      @media (max-width: ${screenSizes.mobile}) {
        top: 0.5rem;
        right: 0.5rem;
        width: 10px;
        height: 10px;
      }
    }
  }

  .card-content {
    padding: 1.5rem;

    @media (max-width: ${screenSizes.mobile}) {
      padding: 1rem;
    }

    h4 {
      font-size: 1.125rem;
      font-weight: 700;
      color: #1e293b;
      margin: 0 0 0.5rem 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 1rem;
        margin-bottom: 0.375rem;
      }
    }

    .card-meta {
      display: flex;
      align-items: center;
      gap: 1rem;
      font-size: 0.875rem;
      color: #64748b;
      margin-bottom: 0.75rem;
      flex-wrap: wrap;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 0.8rem;
        gap: 0.75rem;
        margin-bottom: 0.5rem;
      }

      .meta-item {
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }
    }

    .type-badge {
      display: inline-block;
      padding: 0.25rem 0.75rem;
      background-color: #f1f5f9;
      border-radius: 0.375rem;
      font-size: 0.75rem;
      font-weight: 600;
      color: #475569;
      text-transform: uppercase;
      letter-spacing: 0.05em;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 0.7rem;
        padding: 0.2rem 0.6rem;
      }
    }
  }
`;
